import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  Grid,
  IconButton,
  Divider,
  Chip,
  Stack,
  styled,
  Tooltip,
  Alert,
} from "@mui/material";
import { Edit, ArrowBack } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import CallIcon from "@mui/icons-material/Call";
import CustomTextField from "../common/CustomTextField";
import BadgeIcon from "@mui/icons-material/Badge";
import { CustomNumberField } from "../common";
import { CustomButton, LoadingButton } from "../common/LoadingButton";
import ChangePasswordForm from "../Auth/ChangePasswordForm";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import EditableField from "./EditableField";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import AddressTextField from "../common/Input/AddressTextField";
import { useGlobalData } from "../../contexts/GlobalDataContext";
import { CustomDivider } from "../../assets/styles/MuiStyle";
import HistoryIcon from "@mui/icons-material/History";
import { SubscriptionHistoryDialog } from "../common/Dialog";
const SectionHeader = ({ title, onEdit, isEditable, tooltitle }) => (
  <Box display="flex" alignItems="center" justifyContent="space-between">
    <Typography variant="body1" sx={{ fontSize: "1rem" }}>
      {title}
    </Typography>
    {title === "Payout Setup" ? (
      <CustomButton variant="contained" onClick={onEdit}>
        {tooltitle}
      </CustomButton>
    ) : (
      <Tooltip title={isEditable ? tooltitle : tooltitle}>
        <IconButton onClick={onEdit} aria-label="edit">
          <Edit color={isEditable ? "primary" : "inherit"} />
        </IconButton>
      </Tooltip>
    )}
  </Box>
);

export const SectionContainer = ({ children }) => (
  <Paper elevation={3} sx={{ mt: 2, p: 3 }}>
    <Box p={3}>{children}</Box>
  </Paper>
);

export const ContractDetails = ({ contractUrl }) => {
  const handleDownload = () => {
    const link = document.createElement("a");
    // link.href = `${MEDIA_URL}${contractUrl}`;
    link.href = `${contractUrl}`;
    link.download = "contract_details.pdf";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <SectionContainer>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body1" sx={{ fontSize: "1rem" }}>
          Download Contract Details
        </Typography>
        <Box>
          <Tooltip title="Download Contract">
            <IconButton aria-label="Download Contract" onClick={handleDownload}>
              <DownloadOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </SectionContainer>
  );
};

export const EditProfile = ({
  formik,
  isClient,
  userEmail,
  isAdmin,
  isEditable,
  setIsEditable,
}) => {
  const { user } = useSelector((state) => state.auth);
  const { user_email } = user ?? {};
  const handleEditClick = () => {
    setIsEditable(!isEditable);
  };
  return (
    <SectionContainer>
      <SectionHeader
        title="Personal Details"
        onEdit={handleEditClick}
        isEditable={isEditable}
        tooltitle={"Change Profile"}
      />
      {/* <CustomDivider /> */}
      <Box
        component="form"
        noValidate
        autoComplete="off"
        // sx={{ marginTop: "1rem" }}
        onSubmit={formik.handleSubmit}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {!isAdmin ? (
              <CustomDivider textAlign="left">
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  sx={{ fontWeight: 600 }}
                >
                  Primary Contact Information
                </Typography>
              </CustomDivider>
            ) : (
              <Typography
              variant="subtitle2" 
              gutterBottom
              sx={{
                fontWeight: 600,
                display: 'flex', // Use flex to place text and divider in one line
                alignItems: 'center', // Align text vertically in the center
              }}
            >
              Primary Contact Information
              <Box sx={{ flexGrow: 1, borderBottom: '1px solid #ccc', marginLeft: 2 }} /> {/* Divider line */}
            </Typography>
            
            )}
          </Grid>
          {isClient && (
            <Grid item xs={12} sm={12} lg={isClient ? 6 : 12}>
              <CustomTextField
                id="company_Name"
                label={"Company Name"}
                name={"user_companyname"}
                autoComplete="Name"
                placeholder={"Enter Company Name"}
                endAdornmentIcon={StoreOutlinedIcon}
                formik={formik}
                autoFocus
                disabled={!isEditable}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6} lg={isClient ? 6 : 12}>
            <CustomTextField
              id="user_contactpersonname"
              label={isClient ? "Contact Person Name" : "Full Name"}
              name={isClient ? "user_contactpersonname" : "user_fullname"}
              placeholder={isClient ? "Enter your Name" : "Enter Your Name"}
              autoComplete="user_contactpersonname"
              endAdornmentIcon={BadgeIcon}
              formik={formik}
              disabled={!isEditable}
            />
          </Grid>

          {/* {isAdmin === true ? (
            <Grid item xs={12} sm={6}>
              <CustomTextField
                id="user_email"
                label="Email Id"
                name="user_email"
                autoComplete="user_email"
                value={user_email}
                autoFocus
                disabled
                endAdornmentIcon={EmailOutlinedIcon}
                placeholder={"Enter Your Email"}
                // formik={formik}
              />
            </Grid>
          ) : ( */}
          <Grid item xs={12} sm={6}>
            <EditableField
              label={isClient ? "Email" : "Official Email"}
              userValue={userEmail}
              isAdmin={isAdmin}
              isMobile={false}
              fromEditForm={"email"}
              endAdornmentIcon={EmailOutlinedIcon}
            />
          </Grid>
          {/* )} */}
          {/* {!isAdmin && ( */}
          <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
            <CustomNumberField
              id="Mobile"
              label="Contact Number"
              name="user_mobileno"
              autoComplete="Mobile"
              placeholder="Enter your Contact Number"
              numberFlag={true}
              formik={formik}
              inputProps={{
                maxLength: 15,
              }}
              disabled={!isEditable}
            />
          </Grid>
          {/* )} */}
          <Grid item xs={12}>
            <AddressTextField
              id="Address"
              label={isClient ? "Company Address" : "Address"}
              name="user_address"
              autoComplete="Address"
              placeholder="Enter your Address"
              formik={formik}
              disabled={!isEditable}
            />
          </Grid>

          {!isAdmin && (
            <>
              <Grid item xs={12}>
                <CustomDivider textAlign="left">
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{ fontWeight: 600 }}
                  >
                    Secondary Contact Information
                  </Typography>
                </CustomDivider>
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  id="Secondary Full Name"
                  label={isClient ? "Contact Person Name" : "Full Name"}
                  name={
                    isClient
                      ? "secondary_user_contactpersonname"
                      : "secondary_user_fullname"
                  }
                  autoComplete="Name"
                  placeholder={"Enter your name"}
                  endAdornmentIcon={BadgeIcon}
                  formik={formik}
                  required={false}
                  disabled={!isEditable}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  id="Secondary Email"
                  label={isClient ? "Email" : "Official Email"}
                  name="secondary_user_email"
                  autoComplete="Email"
                  placeholder="Enter your email"
                  endAdornmentIcon={EmailOutlinedIcon}
                  formik={formik}
                  required={false}
                  disabled={!isEditable}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomNumberField
                  id="Secondary Mobile"
                  label="Contact Number"
                  name="secondary_user_mobileno"
                  autoComplete="Mobile"
                  placeholder="Enter your phone number"
                  endAdornmentIcon={CallIcon}
                  numberFlag={true}
                  formik={formik}
                  inputProps={{
                    maxLength: 15,
                  }}
                  required={false}
                  disabled={!isEditable}
                />
              </Grid>
            </>
          )}
        </Grid>
        {isEditable && (
          <Box mt={2}>
            <LoadingButton
              type="submit"
              isLoading={formik.isSubmitting}
              sx={{
                backgroundColor: "#250258",
                fontFamily: "Urbane-Light",
                fontSize: "12px",
              }}
            >
              Update
            </LoadingButton>
          </Box>
        )}
      </Box>
    </SectionContainer>
  );
};

export const SubscriptionDetails = ({ handleOpenDialog, user }) => {
  const {
    subscriptions,
    subscription_count,
    subscription_name,
    user_subscription,
  } = user ?? {};


  console.log(user ,"this is the user details")

  const { subscription_id, plan_id, status, current_period_end } =
    subscriptions[0] ??  {};
  const [open, setOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);
  const handleOpenDialogSub = () => {
    setOpen(true);
  };

  const handleCloseDialogSub = () => {
    setOpen(false);
  };
  const disabledCancelBtn = user_subscription
    ?.filter((row) => row.subscription_status !== "initiated")
    ?.every((sub) => sub.subscription_status === "cancelled");

  return (
    <SectionContainer>
      <Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={2}
        >
          {" "}
          <Box display="flex" alignItems="center">
            <Typography variant="body1" sx={{ fontSize: "1rem" }}>
              Subscription Plan: {subscription_name}
            </Typography>
            <Chip
              sx={{ fontFamily: "Urbane-Light", mx: 1 }}
              label={
                status === "trialing" ? "Trial Version" : status?.toUpperCase()
              }
              color="success"
            />
          </Box>
          <Button size="small" onClick={handleOpenDialogSub}>
            Subscription History
          </Button>
        </Box>
        <CustomDivider />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
        >
          {/* <Typography variant="body1">
          <strong>Last Payment Date:</strong> 10 July 2024
        </Typography> */}
          <Typography variant="body1">
            <strong>Expiry Date:</strong> {current_period_end}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            {subscription_count > 1 ? (
              <NavLink to={`/change-subscription/${plan_id}`}>
                <CustomButton
                  variant="contained"
                  color="primary"
                  sx={{ fontFamily: "Urbane-Light" }}
                >
                  Change Plan
                </CustomButton>
              </NavLink>
            ) : (
              <CustomButton variant="contained" color="primary" disabled>
                Change Plan
              </CustomButton>
            )}{" "}
            <Box ml={3} textAlign="right">
              <CustomButton
                variant="contained"
                color="error"
                sx={{ fontFamily: "Urbane-Light" }}
                onClick={handleOpenDialog}
                disabled={disabledCancelBtn}
              >
                Cancel Subscription
              </CustomButton>
            </Box>{" "}
          </Box>
        </Stack>
      </Box>
      <SubscriptionHistoryDialog
        open={open}
        onClose={handleCloseDialogSub}
        data={user_subscription}
      />
    </SectionContainer>
  );
};
export const BankDetailsForm = ({ formik, user, handleOpenDialog }) => {
  const { handleGenerateLink, stripeLoading } = useGlobalData();
  const { stripe_bankname, stripe_routenumber, connect_pending_points, _id } =
    user ?? {};
  let data = [];
  connect_pending_points?.forEach((entry) => {
    const parts = entry.split("-->");
    data.push(parts);
  });

  const handleEditClick = () => {
    handleOpenDialog();
  };

  return (
    <Box mt={4}>
      <SectionContainer>
        <Box>
          <SectionHeader
            onEdit={handleEditClick}
            title="Payout Setup"
            tooltitle={"Change Stripe Account"}
          />
          <CustomDivider />
          {connect_pending_points?.length > 0 ? (
            <Alert
              severity="error"
              action={
                <CustomButton
                  variant="outlined"
                  color="inherit"
                  size="small"
                  onClick={() => handleGenerateLink(_id?.$oid)}
                >
                  Update
                </CustomButton>
              }
            >
              Your Stripe Account setup is incomplete.
            </Alert>
          ) : (
            <Alert severity="success">
              Your Stripe Account setup is complete.
            </Alert>
          )}

          <Box mt={5}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  id="Bank"
                  label="Bank Name"
                  name="Bank"
                  placeholder="Enter bank name"
                  value={stripe_bankname}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  id="Route"
                  label="Route Number"
                  name={"Account"}
                  placeholder="Enter route number"
                  value={stripe_routenumber}
                  disabled={true}
                />
              </Grid>
            </Grid>
            {/* <Box mt={2}>
              <CustomButton variant="contained" color="primary">
                Submit
              </CustomButton>
            </Box> */}
          </Box>
        </Box>
      </SectionContainer>
    </Box>
  );
};

export const ChangePasswordSection = ({
  formik,
  isEditable,
  setIsEditable,
}) => {
  const handleEditClick = () => {
    setIsEditable(!isEditable);
  };
  return (
    <SectionContainer>
      <SectionHeader
        title="Change Password"
        onEdit={handleEditClick}
        isEditable={isEditable}
        tooltitle={"Change Password"}
      />
      <CustomDivider />
      {isEditable && <ChangePasswordForm formik={formik} update={true} />}
    </SectionContainer>
  );
};
